import React, { Component } from 'react';
import BannerTitle from '../layouts/about/banner/BannerTitle'
import {Header, Footer, TopBar, BottomBar} from '../layouts/general/index'
import {Sidebar, SiteContent} from '../layouts/services/index';

class ServiceDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    logoweb: "assets/img/kliz-logo.jpeg",
                    names: "Product Details",
                }
            ],
            banners: [
                {
                    id: 1,
                    links: '/services',
                    titlelink: 'Products',
                    border: '|',
                    name: 'K.LIZZ Classic Hardware',
                    heading: 'Product Categories'
                }
            ]
        }
    }
    render() {
        return (
            <div className="header-fixed page sidebar-left header-style-2 topbar-style-1 menu-has-search">
                <div id="wrapper" className="animsition">
                    <div id="page" className="clearfix">
                        <div id="site-header-wrap">
                            <TopBar />
                            {
                                this.state.headers.map((data,idx) =>(
                                    <Header data={data} key={idx}/>
                                ))
                            }
                        </div>
                        {
                            this.state.banners.map(data =>(
                                <BannerTitle key={data.id} data={data}/>
                            ))
                        }
                        <div id="main-content" className="site-main clearfix">
                            <div id="content-wrap" className="container">
                                <SiteContent />
                                <Sidebar />
                            </div>
                        </div>
                        <Footer />
                        {
                            this.state.headers.map((data,idx) =>(
                                <BottomBar data={data} key={idx}/>
                            ))
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ServiceDetail;